import { render, staticRenderFns } from "./wageSplit.vue?vue&type=template&id=020a4f79&scoped=true&"
import script from "./wageSplit.vue?vue&type=script&lang=js&"
export * from "./wageSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a4f79",
  null
  
)

export default component.exports